import { render, staticRenderFns } from "./PartnersAnalysesCardsList.vue?vue&type=template&id=3f891698&"
import script from "./PartnersAnalysesCardsList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PartnersAnalysesCardsList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f891698')) {
      api.createRecord('3f891698', component.options)
    } else {
      api.reload('3f891698', component.options)
    }
    module.hot.accept("./PartnersAnalysesCardsList.vue?vue&type=template&id=3f891698&", function () {
      api.rerender('3f891698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/pages/AnalysesListPage/PartnersAnalysesCardsList.vue"
export default component.exports